export type QaChoice = { enabled: boolean; minutes: number };

export function resolveSectionQa(
  flow: QaChoice,
  overrides: Record<string, QaChoice>,
  slotId: string,
  originId?: string,
): QaChoice {
  return overrides[slotId] ?? (originId ? overrides[originId] : undefined) ?? flow;
}

/** Off is the active icon color. On is secondary, under half the slot is a warning, and no time left is an error. */
export function qaNotice(qa: QaChoice, fullMinutes: number | undefined): 'warning' | 'error' | null {
  if (!qa.enabled || fullMinutes == null || fullMinutes <= 0) return null;
  const remaining = fullMinutes - qa.minutes;
  if (remaining <= 0) return 'error';
  if (remaining < fullMinutes / 2) return 'warning';
  return null;
}

export function qaIconColor(
  qa: QaChoice,
  fullMinutes: number | undefined,
): 'action.active' | 'secondary.main' | 'warning.main' | 'error.main' {
  if (!qa.enabled) return 'action.active';
  const notice = qaNotice(qa, fullMinutes);
  if (notice === 'error') return 'error.main';
  if (notice === 'warning') return 'warning.main';
  return 'secondary.main';
}
